import { OutlineButtonContainer } from "@pages/casino/assets/styles/mixins.js";
import { Card } from "antd";
import React from "react";
import { Translate } from "react-localize-redux";

import DefaultCasinoIcon from "@pages/casino/assets/backgrounds/default-casino-icon.png";
import { CloseIcon, DiceIcon, PlayNowIcon, TryAgainIcon } from "@pages/casino/assets/icons";
import { Modal } from "@pages/casino/components";

import {
	CardContentWrapper,
	CardTitle,
	CardWrapper,
	ContentWrapper,
	GameAffiliateName,
	GameName,
	ImageContentWrapper,
	ImageWrapper,
	PlayNowButton,
	TryAgainButton,
} from "./elements.js";
import useController from "./useController.js";

const IFeelLuckyModal = () => {
	const {
		state: { isToggled, randomGame, casinoGames },
		handlers: { handleToggleChange, handlePlayButtonClick, handleGameSelect },
	} = useController();

	return (
		<Translate>
			{({ translate }) => (
				<>
					<OutlineButtonContainer onClick={handleToggleChange}>
						<DiceIcon />
						<span>{translate("casino.ifeellucky")}</span>
					</OutlineButtonContainer>
					<Modal
						position={"centered"}
						open={isToggled}
						onClose={handleToggleChange}>
						{casinoGames.length == 0 ? null : (
							<ContentWrapper>
								<CardWrapper>
									<Card>
										<CardTitle>{translate("YOU_ARE_LUCKY")}</CardTitle>
										<CardContentWrapper>
											<ImageWrapper>
												<img
													className="big-image"
													src={`${
														randomGame?.icon_custom_url
															? randomGame?.icon_custom_url
															: randomGame?.game_icon_url
																? randomGame?.game_icon_url
																: DefaultCasinoIcon
													}`}
												/>
											</ImageWrapper>
											<ImageContentWrapper>
												<GameAffiliateName>
													{randomGame?.affiliate}
												</GameAffiliateName>
												<GameName>{randomGame?.remote_name}</GameName>
												<PlayNowButton onClick={handlePlayButtonClick}>
													<PlayNowIcon />
													{translate("PLAY_NOW")}
												</PlayNowButton>
												<TryAgainButton onClick={handleGameSelect}>
													<TryAgainIcon />
													{translate("TRY_AGAIN")}
												</TryAgainButton>
											</ImageContentWrapper>
										</CardContentWrapper>
									</Card>
								</CardWrapper>
								<CloseIcon
									className="modal-close-icon"
									onClick={handleToggleChange}
								/>
							</ContentWrapper>
						)}
					</Modal>
				</>
			)}
		</Translate>
	);
};

export default IFeelLuckyModal;
